import { simpleSet } from '@r/reducers/utils';

const setCalculationModeDrawerSystemsOptions = simpleSet as
  redux.reducers.calculationMode.projects.currentProject.settings.materials.drawerSystems.options;

export const options = setCalculationModeDrawerSystemsOptions(
  'SET_CALCULATION_MODE_CURRENT_PROJECT_DRAWER_SYSTEMS_OPTIONS',
  []
);
